/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const RocketLaunchSolidV6 = (props) => (
  <Icon {...props} name="Rocket Launch Solid V6">
    <path d="M3.681 3.972h2.788C8.966-.117 12.797-.267 15.122.164c.366.067.647.35.713.713.431 2.326.281 6.157-3.834 8.626v2.816a2.25 2.25 0 0 1-1.103 1.937l-2.766 1.638a.753.753 0 0 1-.753.009.753.753 0 0 1-.378-.653v-3.584c0-.709-.281-1.412-.781-1.912s-1.175-.753-1.884-.753H.752c-.269 0-.518-.144-.652-.378s-.131-.522.007-.753l1.64-2.766c.405-.684 1.141-1.131 1.937-1.131zM12 2.75a1.25 1.25 0 1 0-.002 2.498A1.25 1.25 0 0 0 12 2.75zM5.203 14.687C3.656 16.234.015 15.984.015 15.984s-.25-3.669 1.297-5.187a2.75 2.75 0 1 1 3.891 3.891zm-1.459-2.431a.917.917 0 0 0-1.294 0c-.514.516-.431 1.725-.431 1.725s1.21.084 1.726-.431a.917.917 0 0 0 0-1.294z" />
  </Icon>
);

export default RocketLaunchSolidV6;
